import React from "react";
import EventList from "./EventList";

function EventSection({ selectedDate }) {
  return (
    <div>
      <h2 className="border-b-2 border-[gainsboro] bg-white w-[60%] mx-auto items-center flex-col justify-center font-serif text-center text-blue-800 text-xl uppercase rounded-xl">
        Events
      </h2>
      <EventList selectedDate={selectedDate} />
    </div>
  );
}

export default EventSection;
